import { IAuth } from "@kunduz/data-access-auth-api";

/**
 * serializez multiple profile info to single string
 */
export function serializeProfiles(
  profiles: IAuth.IVerifyOtpResponse["profiles"],
): string {
  const result: string[] = [];

  if (profiles.school_staff) result.push("school_staff");
  if (profiles.parent) result.push("parent");
  if (profiles.teacher) result.push("teacher");
  if (profiles.student) result.push("student");

  return result.join(",");
}

/**
 * checks if wanted profile exists in profiles
 */
export function hasProfileInSerializedProfiles(
  profile: string,
  serializedProfiles: string,
): boolean {
  return serializedProfiles.indexOf(profile) > -1;
}
